(()=>{
 const root=document.querySelector('#KsGearBuy-ks-gear-helm,#KsGearBuy-knr-081');
 if(!root)return;
 if(root.id==='KsGearBuy-knr-081'){
  const heading=root.querySelector('h1');
  if(heading&&!heading.querySelector('.hb-highlight')){
   const text=heading.textContent;
   const split=text.toLowerCase().indexOf('both jobs');
   if(split>-1){
    const highlight=document.createElement('span');highlight.className='hb-highlight';highlight.textContent=text.slice(split);
    heading.replaceChildren(document.createTextNode(text.slice(0,split)),highlight);
   }
  }
 }
 root.querySelectorAll('a.ks-assurance-item').forEach(link=>{
  const item=document.createElement('div');item.className=link.className;
  while(link.firstChild)item.append(link.firstChild);
  link.replaceWith(item);
 });
})();
